import apiClient from './core/ApiClient'
import { PartnerExpense } from 'src/api/PartnerExpense';
import { PartnersExpenseFindResponse } from 'src/api/PartnersExpenseFindResponse';
import { PartnersExpenseListResponse } from 'src/api/PartnersExpenseListResponse';
import { PartnersExpenseStoreRequest } from 'src/api/PartnersExpenseStoreRequest';

const root = '/api/partners/expenses';

const add = (expense: PartnerExpense): Promise<void> => {
    let payload: PartnersExpenseStoreRequest = {
        summary: expense
    }
    return apiClient.post<PartnersExpenseStoreRequest, void>(root, payload);
}

const update = (expense: PartnerExpense): Promise<void> => {
    let payload: PartnersExpenseStoreRequest = {
        summary: expense
    }
    return apiClient.put<PartnersExpenseStoreRequest, void>(root, payload);
}

const remove = (id: number): Promise<void> => apiClient.delete<void>(`${root}/${id}`);

const find = (id: number): Promise<PartnerExpense> => apiClient.get<PartnersExpenseFindResponse>(`${root}/${id}`).then(r => r.expense);

const listAll = (): Promise<PartnersExpenseListResponse> => apiClient.get<PartnersExpenseListResponse>(root);

export const expenseService = {
    add,
    update,
    remove,
    find,
    listAll,
}